import { Language } from 'core/models/common';
import i18n from 'i18n';

export const onChangeLanguage = () => {
	if (i18n.language == 'ar') {
		i18n.changeLanguage('en');
		localStorage.setItem('language', 'en');
	} else {
		i18n.changeLanguage('ar');
		localStorage.setItem('language', 'ar');
	}
};

export const getDefaultLanguage = (): Language => {
	return (localStorage.getItem('language') || 'en') as Language;
};

export const isRTL = () => {
	return i18n.dir() == 'rtl';
};
